<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">

      <a-form-model-item label="tab页名称" prop="name" >
        <a-input style="width: 250px" v-model="form.name" placeholder="请输入tab页名称" />
      </a-form-model-item>

      <a-form-model-item label="类型" prop="type" >
        <a-input style="width: 250px" v-model="form.type" placeholder="请输入tab码" />
      </a-form-model-item>

      <a-form-model-item label="tab页图片" prop="img" >
        <OssMultiUploadSingle v-model="form.img" type="img" :maxSize="10"></OssMultiUploadSingle>
      </a-form-model-item>

      <a-form-model-item label="页面路径" prop="url" >
        <a-input style="width: 250px" v-model="form.url" placeholder="请输入页面地址" />
      </a-form-model-item>

      <a-form-model-item label="是否默认选中" prop="isSelect" >
        <a-select style="width: 250px" v-model="form.isSelect" placeholder="请选择">
          <a-select-option value="false">否</a-select-option>
          <a-select-option value="true">是</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="样式" prop="style" >
        <a-select style="width: 250px" v-model="form.style" placeholder="请选择样式">
          <a-select-option v-for="(item, index) in this.customDict.TabStyleEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="排序" prop="sort" >
        <a-input-number style="width: 250px" v-model="form.sort" placeholder="请输入排序" />
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getTabs, addTabs, updateTabs } from '@/api/config/tabs'
import OssMultiUpload from '@/views/script/script/modules/OssMultiUpload.vue'
import OssMultiUploadSingle from '@/views/script/script/modules/OssMultiUploadSingle.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    OssMultiUpload, OssMultiUploadSingle
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        type: null,
        name: null,
        img: null,
        url: null,
        isSelect: null,
        style: null,
        sort: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        type: [
          { required: true, message: '类型不能为空', trigger: 'change' }
        ],

        name: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ],

        sort: [
          { required: true, message: '排序不能为空', trigger: 'blur' }
        ]

      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        type: null,
        name: null,
        img: null,
        url: null,
        isSelect: null,
        style: null,
        sort: null
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getTabs(id).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateTabs(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addTabs(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
